export default function Logo() {
  return (
    <div>
      <img src="/logo.svg" alt="Protocol.store" />
    </div>
  )
}
